import { createRemixElement } from './core/vnode.js';
export function jsx(type, props, key) {
    return createRemixElement(type, props, key);
}
export { jsx as jsxDEV, jsx as jsxs };
//# sourceMappingURL=jsx.js.map